import { render, staticRenderFns } from "./CommunityPromotion.vue?vue&type=template&id=8b4f7538&scoped=true&"
import script from "./CommunityPromotion.vue?vue&type=script&lang=js&"
export * from "./CommunityPromotion.vue?vue&type=script&lang=js&"
import style0 from "./CommunityPromotion.vue?vue&type=style&index=0&id=8b4f7538&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b4f7538",
  null
  
)

export default component.exports